import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesUp, faAnglesDown, faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import USQSFormGroup from "./USQSFormGroup";
import {
  handlePaytermInputChange,
  handlePaytermInputBlur,
  SelectPayType,
  handleDelPayRow,
  handleAddPayRow,
} from "./utils/inputhandlers";
import useUSQS from "../../hooks/useUSQS";
import useUSQSUndo from "../../hooks/useUSQSUndo";

const QSUSAPayment = ({
  ignoreEnter,
  clearfield,
  loadedPpayterm,
  loadedPpaytermData,
  loadedSpayterm,
  loadedSpaytermData,
}) => {
  // Load Context Values
  const {
    ppaymenttermUSQS,
    setPpaymenttermUSQS,
    ppaymenttermDataUSQS,
    setPpaymenttermDataUSQS,
    ppayrowUSQS,
    spaymenttermUSQS,
    setSpaymenttermUSQS,
    spaymenttermDataUSQS,
    setSpaymenttermDataUSQS,
    spayrowUSQS,
    qstoedit,
    USQS,
  } = useUSQS();
  const {
    setEditingFieldUSQS,
    USQSEdits,
    editIDUSQS,
    setEditIDUSQS,
    editingFieldUSQS,
    undoListUSQS,
    setReloadpayterms,
    inputRefsUSQS,
  } = useUSQSUndo();
  return (
    <>
      <fieldset>
        <legend>
          Purchase Payment Terms:
          {USQS.qstype !== 2 && (
            <FontAwesomeIcon
              icon={faPlusSquare}
              onClick={(e) =>
                handleAddPayRow(
                  setPpaymenttermUSQS,
                  setPpaymenttermDataUSQS,
                  ppayrowUSQS,
                  USQSEdits,
                  editIDUSQS,
                  setEditIDUSQS,
                  undoListUSQS,
                  loadedPpayterm,
                  loadedPpaytermData,
                  qstoedit,
                  "purchase"
                )
              }
            />
          )}
        </legend>
        <USQSFormGroup
          readOnly={USQS.qstype === 2}
          labelname={"Interest Rate"}
          inputname={"pinterest"}
          inputtype={"percent"}
          style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
        />
        <div className='USpayterms'>
          <div className='USpayterm-headers'>
            <p></p>
            <p>Portion</p>
            <p>Type</p>
            <p>Days</p>
          </div>
          {ppaymenttermUSQS &&
            ppaymenttermUSQS.map((el, ind) => {
              let paykeys = Object.keys(el);
              return (
                <div key={"pposrowpay-" + ind} className='USpayterm-content'>
                  <p>{ind + 1 + ":"}</p>
                  {paykeys &&
                    paykeys.map((el1) => {
                      if (
                        el1 !== "USQSID" &&
                        el1 !== "QSPaytermID" &&
                        el1 !== "row" &&
                        el1 !== "type" &&
                        el1 !== "origin"
                      ) {
                        if (el1 !== "payType" || USQS.qstype === 2) {
                          return (
                            <input
                              readOnly={USQS.qstype === 2}
                              className={USQS.qstype === 2 ? "usqsreadonlyinput" : ""}
                              tabIndex={USQS.qstype === 2 && -1}
                              required
                              id={el1 + ind}
                              autoComplete='off'
                              key={ind + "-" + el1}
                              name={el1}
                              value={el[el1]}
                              onFocus={(e) => USQS.qstype !== 2 && e.target.select()}
                              onChange={(e) => {
                                USQS.qstype !== 2 &&
                                  handlePaytermInputChange(
                                    ind,
                                    el1,
                                    e,
                                    ppaymenttermUSQS,
                                    ppaymenttermDataUSQS,
                                    setPpaymenttermUSQS,
                                    setPpaymenttermDataUSQS,
                                    setEditingFieldUSQS
                                  );
                              }}
                              onBlur={(e) => {
                                USQS.qstype !== 2 &&
                                  handlePaytermInputBlur(
                                    ind,
                                    el1,
                                    e,
                                    ppaymenttermUSQS,
                                    setPpaymenttermUSQS,
                                    USQSEdits,
                                    editingFieldUSQS,
                                    editIDUSQS,
                                    setEditIDUSQS,
                                    setEditingFieldUSQS,
                                    undoListUSQS,
                                    ppaymenttermDataUSQS,
                                    "purchase"
                                  );
                              }}
                              onKeyDown={ignoreEnter}
                              ref={(elem) => {
                                return (inputRefsUSQS.current["purchase" + el1 + (el?.posPaytermID || el?.row)] = elem);
                              }}
                            />
                          );
                        } else {
                          return (
                            <SearchField
                              key={ind + "-" + el1}
                              required={true}
                              searchURL='/api/positions/getpaytypes'
                              value={el[el1] || ""}
                              valueName='payType'
                              refName={"purchasepayType" + (el.posPaytermID || el.row)}
                              valueID='payTypeID'
                              style={{ width: "40px" }}
                              customplaceholder='payType'
                              onItemSelect={(item) => {
                                SelectPayType(
                                  item,
                                  ind,
                                  ppaymenttermUSQS,
                                  setPpaymenttermUSQS,
                                  ppaymenttermDataUSQS,
                                  setPpaymenttermDataUSQS,
                                  editingFieldUSQS,
                                  USQSEdits,
                                  editIDUSQS,
                                  el1,
                                  setEditIDUSQS,
                                  setEditingFieldUSQS,
                                  undoListUSQS,
                                  "purchase"
                                );
                              }}
                              clearfield={clearfield}
                            />
                          );
                        }
                      }
                    })}{" "}
                  {USQS.qstype !== 2 && (
                    <p>
                      <FontAwesomeIcon
                        style={{ marginLeft: "0.4rem" }}
                        icon={faMinusSquare}
                        onClick={(e) =>
                          handleDelPayRow(
                            ppaymenttermUSQS,
                            ppaymenttermDataUSQS,
                            setPpaymenttermUSQS,
                            setPpaymenttermDataUSQS,
                            setReloadpayterms,
                            ind,
                            USQSEdits,
                            editIDUSQS,
                            setEditIDUSQS,
                            undoListUSQS,
                            ppayrowUSQS,
                            loadedPpayterm,
                            loadedPpaytermData,
                            "purchase"
                          )
                        }
                      />
                    </p>
                  )}
                </div>
              );
            })}
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Sales Payment Terms:
          <FontAwesomeIcon
            icon={faPlusSquare}
            onClick={(e) =>
              handleAddPayRow(
                setSpaymenttermUSQS,
                setSpaymenttermDataUSQS,
                spayrowUSQS,
                USQSEdits,
                editIDUSQS,
                setEditIDUSQS,
                undoListUSQS,
                loadedSpayterm,
                loadedSpaytermData,
                qstoedit,
                "sales"
              )
            }
          />
        </legend>
        <USQSFormGroup
          labelname={"Interest Rate"}
          inputname={"sinterest"}
          inputtype={"percent"}
          style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
        />
        <div className='USpayterms'>
          <div className='USpayterm-headers'>
            <p></p>
            <p>Portion</p>
            <p>Type</p>
            <p>Days</p>
          </div>
          {spaymenttermUSQS &&
            spaymenttermUSQS.map((el, ind) => {
              let paykeys = Object.keys(el);
              return (
                <div key={"pposrowpay-" + ind} className='USpayterm-content'>
                  <p>{ind + 1 + ":"}</p>
                  {paykeys &&
                    paykeys.map((el1) => {
                      if (
                        el1 !== "USQSID" &&
                        el1 !== "QSPaytermID" &&
                        el1 !== "row" &&
                        el1 !== "type" &&
                        el1 !== "origin"
                      ) {
                        if (el1 !== "payType") {
                          return (
                            <input
                              required
                              id={el1 + ind}
                              autoComplete='off'
                              key={ind + "-" + el1}
                              name={el1}
                              value={el[el1]}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => {
                                handlePaytermInputChange(
                                  ind,
                                  el1,
                                  e,
                                  spaymenttermUSQS,
                                  spaymenttermDataUSQS,
                                  setSpaymenttermUSQS,
                                  setSpaymenttermDataUSQS,
                                  setEditingFieldUSQS
                                );
                              }}
                              onBlur={(e) => {
                                handlePaytermInputBlur(
                                  ind,
                                  el1,
                                  e,
                                  spaymenttermUSQS,
                                  setSpaymenttermUSQS,
                                  USQSEdits,
                                  editingFieldUSQS,
                                  editIDUSQS,
                                  setEditIDUSQS,
                                  setEditingFieldUSQS,
                                  undoListUSQS,
                                  spaymenttermDataUSQS,
                                  "sales"
                                );
                              }}
                              onKeyDown={ignoreEnter}
                              ref={(elem) => {
                                return (inputRefsUSQS.current["sales" + el1 + (el?.posPaytermID || el?.row)] = elem);
                              }}
                            />
                          );
                        } else {
                          return (
                            <SearchField
                              key={ind + "-" + el1}
                              required={true}
                              searchURL='/api/positions/getpaytypes'
                              value={el[el1] || ""}
                              valueName='payType'
                              refName={"salespayType" + (el.posPaytermID || el.row)}
                              valueID='payTypeID'
                              style={{ width: "40px" }}
                              customplaceholder='payType'
                              onItemSelect={(item) => {
                                SelectPayType(
                                  item,
                                  ind,
                                  spaymenttermUSQS,
                                  setSpaymenttermUSQS,
                                  spaymenttermDataUSQS,
                                  setSpaymenttermDataUSQS,
                                  editingFieldUSQS,
                                  USQSEdits,
                                  editIDUSQS,
                                  el1,
                                  setEditIDUSQS,
                                  setEditingFieldUSQS,
                                  undoListUSQS,
                                  "sales"
                                );
                              }}
                              clearfield={clearfield}
                            />
                          );
                        }
                      }
                    })}{" "}
                  <p>
                    <FontAwesomeIcon
                      style={{ marginLeft: "0.4rem" }}
                      icon={faMinusSquare}
                      onClick={(e) =>
                        handleDelPayRow(
                          spaymenttermUSQS,
                          spaymenttermDataUSQS,
                          setSpaymenttermUSQS,
                          setSpaymenttermDataUSQS,
                          setReloadpayterms,
                          ind,
                          USQSEdits,
                          editIDUSQS,
                          setEditIDUSQS,
                          undoListUSQS,
                          spayrowUSQS,
                          loadedSpayterm,
                          loadedSpaytermData,
                          "sales"
                        )
                      }
                    />
                  </p>
                </div>
              );
            })}
        </div>
      </fieldset>
    </>
  );
};

export default QSUSAPayment;
